mainApp.component('authConfiguration',{
    templateUrl: '/public/components/authConfiguration.html',
    bindings: {
        model: '=',
								externalSystem: '=',
        isOverrideComponent: '=',
        changesListener: '&',
    },
    controller: authConfigurationController
});

function authConfigurationController($scope, $state, CloudAccessService){
    const $ctrl = this;
				$ctrl.SSOLoginEnabled = false;
				$ctrl.provider = "";

    $ctrl.$onInit = function() {
    				$ctrl.isSSOLoginEnabled();
    				$ctrl.initProvider();
       reload();
    }

    //checks if there were changed in the component and calls the changes listener
    $ctrl.$doCheck = function() {
												if (!$ctrl.changesListener)
            return;

        const isChangedNow = $ctrl.model.vpnAuthMethod !== $ctrl.original.vpnAuthMethod ||
												!angular.equals($ctrl.model.mfaConfiguration, $ctrl.original.mfaConfiguration) ||
												($ctrl.model.ssoCookieSettings && !angular.equals($ctrl.model.ssoCookieSettings,$ctrl.original.ssoCookieSettings));

        //check if listener was already called and updates about having changes
        if ($ctrl.hasChanges === isChangedNow)
            return;

        $ctrl.hasChanges = isChangedNow;
        $ctrl.changesListener({isDirty: $ctrl.hasChanges, componentName: 'mfaConfiguration'});
    }

    //the model was changed and settings need to be reloaded
    $scope.$on('modelReloadedEvent', function (event, data) {
        reload();
    });

    function reload() {
     $ctrl.original = angular.copy($ctrl.model);

        //if the component is a user settings component we get the global account settings to show them if needed (in case user un-checks "override" checkbox)
        if($ctrl.isOverrideComponent){
            getAccountConfiguration();
        }
        loadExternalSystems();
        $scope.vpnAuthMethodOptions[2].disabled = false;

				}

    //gets domain information from the account to indicate if SSO is enabled
    function loadExternalSystems() {
        store.fetch({
            path: '/getExternalSystems',
            queryParams: { accountId: $state.params.accountId },
            success: function (data) {
                $ctrl.externalSystemInfo = data;
            },
        });
    }

    //gets the account authentication configuration to show in case user configuration doesn't override account's (override checkbox unchecked)
    function getAccountConfiguration() {
        $ctrl.accountCookieSettings = {};

        //get account auth method to show in case user configuration doesn't override account's
        store.fetch({
            path: '/getAccountVpnAuthMethod?accountId=' + $state.params.accountId,
            success: function (data) {
                $ctrl.accountVpnAuthMethod = data;

                if($ctrl.accountVpnAuthMethod === 'MFA'){
                    //get account mfa configuration to show in case user configuration doesn't override account's
                    store.fetch({
                        path: '/getAccountMFAConfiguration?accountId=' + $state.params.accountId,
                        success: function (data) {
                            //save account mfa mode for a case the user removes override checkbox - than we'll show the account MFA configuration
                            $ctrl.accountMfaMode = data.mfaMode;
                            $ctrl.accountMfaAuthMethod = data.mfaAuthMethod;

                            $ctrl.accountCookieSettings.enforceCookieDuration = data.cookieSettings.enforceCookieDuration;
                            $ctrl.accountCookieSettings.cookieDuration = data.cookieSettings.cookieDuration;
                            $ctrl.accountCookieSettings.cookieTimeUnit = data.cookieSettings.cookieTimeUnit;
                        }
                    });
                }
                //get account SSO configuration in case of not override
                else if ($ctrl.accountVpnAuthMethod === 'SSO') {
                    store.fetch({
                        path: '/getAccountSSOCookieSettings?accountId=' + $state.params.accountId,
                        success: function (data) {
                            //save account mfa mode for a case the user removes override checkbox - than we'll show the account MFA configuration
                            $ctrl.accountCookieSettings.enforceCookieDuration = data.enforceCookieDuration;
                            $ctrl.accountCookieSettings.cookieDuration = data.cookieDuration;
                            $ctrl.accountCookieSettings.cookieTimeUnit = data.cookieTimeUnit;
                        }
                    });
                }
            }
        });
     }

    //checks if configuration should be disabled - if it is an override component (vpn user) and override checkbox wasn't selected
    $scope.isOverrideConfiguration = function(){
        return !$ctrl.isOverrideComponent || ($ctrl.isOverrideComponent && $ctrl.model.isOverrideAuthSettings);
    }

				$ctrl.isSSOLoginEnabled = function(){
								CloudAccessService.isSSOLoginEnabled($state.params.accountId, function(data) {
												$ctrl.SSOLoginEnabled = data;
								});
				}

				$ctrl.initProvider = function(){
								CloudAccessService.getSsoProvider($state.params.accountId, function(data) {
												$ctrl.provider = data;
												//disable SSO configuration if user is not imported from LDAP/SCIM and the provider is not google
												$scope.vpnAuthMethodOptions[2].disabled = false;
								});
				}

    $scope.getUserSelection = function(){
      if ($ctrl.model.mfaConfiguration.endUserMfaAuthMethod === 'SMS'){
          return 'SMS';
      }
      else if($ctrl.model.mfaConfiguration.endUserMfaAuthMethod === 'GOOGLE_AUTH') {
          return 'Authenticator';
      }
      else return 'Not yet selected';

    }

    $scope.showOsIcons = function(){
        return $ctrl.model && $ctrl.model.vpnAuthMethod !== $ctrl.original.vpnAuthMethod && $ctrl.model.vpnAuthMethod !== 'NONE';
    }

    $scope.vpnAuthMethodOptions = [
        {
            value: 'NONE',
            key: 'None'
        },
        {
            value: 'MFA',
            key: 'MFA'
        },
        {
            value: 'SSO',
            key: 'SSO'
        }
    ];

     $scope.mfaModeOptions = [
         {
            value: 'ENABLED',
            key: 'Enabled'
         },
         {
            value: 'END_USER_DEFINED',
            key: 'End-user defined'
         }
     ];

    $scope.mfaAuthMethodOptions = [
        {
            value: 'ANY',
            key: 'Any'
        },
        {
            value: 'GOOGLE_AUTH',
            key: 'Authenticator'
        },
        {
            value: 'SMS',
            key: 'SMS'
        }
    ];
}
